// 测试代码
const a = () => import(/* webpackChunkName: 'thome' */ './1');
const b = () => import(/* webpackChunkName: 'thome' */ './2');
const c = () => import(/* webpackChunkName: 'thome' */ './3');
const d = () => import(/* webpackChunkName: 'thome' */ './4');
const e = () => import(/* webpackChunkName: 'thome' */ './5');
const f = () => import(/* webpackChunkName: 'thome' */ './6');
const g = () => import(/* webpackChunkName: 'thome' */ './7');
const h = () => import(/* webpackChunkName: 'thome' */ './8');
const i = () => import(/* webpackChunkName: 'thome' */ './9');

const routes = [
  { path: '/thome/1', component: a },
  { path: '/thome/2', component: b },
  { path: '/thome/3', component: c },
  { path: '/thome/4', component: d },
  { path: '/thome/5', component: e },
  { path: '/thome/6', component: f },
  { path: '/thome/7', component: g },
  { path: '/thome/8', component: h },
  { path: '/thome/9', component: i },
];

export default routes;